import { useState, useEffect, useRef } from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import KampanyaVitrini from "./components/KampanyaVitrini";
import KampanyaDetay from "./components/KampanyaDetay";
import IkinciAdim from "./components/IkinciAdim";
import LeadPopup from "./components/LeadPopup";
import RandevuPopup from "./components/RandevuPopup";
import FinalCTA from "./components/FinalCTA";
import WhatsAppButton from "./components/WhatsAppButton";
import Footer from "./components/Footer";
import MusteriYorumlari from "./components/MusteriYorumlari";
import OnceSonra from "./components/OnceSonra";
import SSS from "./components/SSS";
import { type Kampanya } from "@/mocks/kampanyalar";

type Adim = "vitrin" | "detay" | "ikinci" | "final";

export default function Home() {
  const [adim, setAdim] = useState<Adim>("vitrin");
  const [seciliKampanya, setSeciliKampanya] = useState<Kampanya | null>(null);
  const [popupAcik, setPopupAcik] = useState(false);
  const [popupGosterildi, setPopupGosterildi] = useState(false);
  const [randevuPopupAcik, setRandevuPopupAcik] = useState(false);
  const detayRef = useRef<HTMLDivElement>(null);
  const ikinciRef = useRef<HTMLDivElement>(null);
  const finalRef = useRef<HTMLDivElement>(null);

  // Auto popup after 30 seconds
  useEffect(() => {
    if (popupGosterildi) return;
    const timer = setTimeout(() => {
      setPopupAcik(true);
      setPopupGosterildi(true);
    }, 30000);
    return () => clearTimeout(timer);
  }, [popupGosterildi]);



  const scrollToSection = (ref: React.RefObject<HTMLDivElement | null>) => {
    setTimeout(() => {
      ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };

  const handleDetayClick = (kampanya: Kampanya) => {
    setSeciliKampanya(kampanya);
    setAdim("detay");
    scrollToSection(detayRef);
  };

  const handleDevamEt = () => {
    setAdim("ikinci");
    scrollToSection(ikinciRef);
  };

  const handleFirsatlariGor = () => {
    setAdim("final");
    setPopupAcik(true);
    setPopupGosterildi(true);
    scrollToSection(finalRef);
  };

  const handleGeri = () => {
    setAdim("vitrin");
    const el = document.getElementById("kampanyalar");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const handleKampanyaScrollClick = () => {
    const el = document.getElementById("kampanyalar");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const handleBilgiAlClick = () => {
    setPopupAcik(true);
    setPopupGosterildi(true);
  };

  const handleRandevuClick = () => {
    setRandevuPopupAcik(true);
  };

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
      {/* Google Fonts */}
      <link
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700;800&family=Inter:wght@300;400;500;600;700&display=swap"
        rel="stylesheet"
      />

      <Navbar onRandevuClick={handleRandevuClick} />

      {/* Hero */}
      <HeroSection
        onKampanyaClick={handleKampanyaScrollClick}
        onBilgiAlClick={handleBilgiAlClick}
      />

      {/* Kampanya Vitrini - always visible */}
      <KampanyaVitrini onDetayClick={handleDetayClick} />

      {/* Müşteri Yorumları */}
      <MusteriYorumlari />

      {/* Önce / Sonra Galerisi */}
      <OnceSonra />

      {/* SSS */}
      <SSS />

      {/* Kampanya Detay - shown when a campaign is selected */}
      {seciliKampanya && (adim === "detay" || adim === "ikinci" || adim === "final") && (
        <div ref={detayRef}>
          <KampanyaDetay
            kampanya={seciliKampanya}
            onDevamEt={handleDevamEt}
            onGeri={handleGeri}
          />
        </div>
      )}

      {/* İkinci Adım */}
      {seciliKampanya && (adim === "ikinci" || adim === "final") && (
        <div ref={ikinciRef}>
          <IkinciAdim
            kampanya={seciliKampanya}
            onFirsatlariGor={handleFirsatlariGor}
          />
        </div>
      )}

      {/* Final CTA - always at bottom */}
      <div ref={finalRef}>
        <FinalCTA onRandevuClick={handleRandevuClick} />
      </div>

      <Footer />

      {/* WhatsApp Floating */}
      <WhatsAppButton />

      {/* Lead Popup */}
      {popupAcik && (
        <LeadPopup
          onClose={() => setPopupAcik(false)}
          onSuccess={() => {
            setPopupAcik(false);
            const el = document.getElementById("final-cta");
            if (el) el.scrollIntoView({ behavior: "smooth" });
          }}
        />
      )}

      {/* Randevu Popup */}
      {randevuPopupAcik && (
        <RandevuPopup onClose={() => setRandevuPopupAcik(false)} />
      )}
    </div>
  );
}
